import { usePathname } from 'next/navigation'

import ROUTES from 'config/routes.json'
import MenuItem from 'containers/Menu/MenuItem'
import { useAppSelector } from 'src/store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import tabsUrls from 'temp/tabsUrls.json'

import type { ComponentType, ReactNode } from 'react'

type Props = {
  children?: ReactNode
  link?: string | string[]
  text?: string
  icon: ReactNode | ComponentType<any>
  onClick?: () => void
  key?: number
  promoCategoriesPaths: string[]
  dataTestId?: string
}

export default function MenuLink(props: Props) {
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const pathname = usePathname()
  const { link, promoCategoriesPaths } = props

  const isSlotsTab =
    [...tabsUrls.AllGamesTabs, ...promoCategoriesPaths].includes(pathname) &&
    link === '/slots' &&
    pathname !== '/slots/top' &&
    pathname !== '/slots/live-social-casino' &&
    pathname !== '/table-games' &&
    pathname !== '/favorites' &&
    pathname !== '/providers'

  const isMyAccountTab = tabsUrls.MyAccountLinks.includes(pathname) && link === '/my-account'
  const isMyGamesTab = tabsUrls.MyGamesTabs.includes(pathname) && link?.includes('/previously-played')
  const isProvidersTab = pathname.includes('/providers') && link?.includes('/providers')
  const isTabLink = isSlotsTab || isMyGamesTab || isProvidersTab
  let isActive

  if (Array.isArray(link)) {
    isActive = (link.includes(pathname) || isTabLink || isMyAccountTab) && appInitialized
  } else {
    isActive = (link === pathname || isTabLink || isMyAccountTab) && appInitialized
  }
  const currentLink: string = link && Array.isArray(link) ? (link[0] as string) : (link as string)

  if (currentLink) {
    return (
      <MenuItem
        {...props}
        dataTestId={`menu-link-${props.text}`}
        isActive={isActive}
        href={currentLink || ROUTES.HOME}
      />
    )
  }

  return <MenuItem dataTestId={`menu-link-${props.text}`} {...props} isActive={isActive} />
}
